import {
  Button,
  ErrorAlert,
  RatingTextInput,
  SuccessAlert,
} from '@/components';
import { useFeedback } from '@/components/providers/postauth/FeedbackProvider';
import APP_CONFIG from '@/config/app';
import { FEEDBACK } from '@/utils/strings';
import { FC, useState } from 'react';
const { MAIN_GAP } = APP_CONFIG.STYLES;
interface FeedbackFormProps {}
const FeedbackForm: FC<FeedbackFormProps> = () => {
  const [feedback, setFeedback] = useState('');
  const { submitFeedback, isLoading, error, success, clearStatus } =
    useFeedback();
  const handleChange = (value: string) => {
    setFeedback(value);
    if (error || success) {
      clearStatus();
    }
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (feedback.trim()) {
      await submitFeedback(feedback.trim());
      setFeedback('');
    }
  };
  return (
    <form
      onSubmit={handleSubmit}
      className={`flex flex-col gap${MAIN_GAP} w-full`}
    >
      <RatingTextInput
        value={feedback}
        onChange={handleChange}
        name="feedback"
        placeholder={FEEDBACK.FORM.PLACEHOLDER}
        multiLine
        noOfLines={6}
        errors={{}}
        className="w-full"
      />
      <Button
        type="submit"
        intent="primary"
        loading={isLoading}
        disabled={!feedback.trim() || isLoading}
      >
        {FEEDBACK.FORM.SUBMIT_BUTTON}
      </Button>
      {error && (
        <ErrorAlert
          title={FEEDBACK.FORM.ERROR_ALERT_TITLE}
          description={error}
        />
      )}
      {success && (
        <SuccessAlert
          title={FEEDBACK.FORM.SUCCESS_ALERT_TITLE}
          description={success}
        />
      )}
    </form>
  );
};
export default FeedbackForm;
